import { collection, doc, type FirestoreDataConverter, getFirestore } from 'firebase/firestore'
import { type z } from 'zod'

import { TransportRequestZod } from '@/model/firestore/schema/TransportRequestZod.ts'
import { ErrorWithSentryCaptureContext } from '@/sentry/ErrorWithSentryCaptureContext.ts'

export type TransportRequestSnapshotData = z.infer<typeof TransportRequestZod> & { _id: string }

const TransportRequestConverter: FirestoreDataConverter<TransportRequestSnapshotData> = {
  toFirestore: (data) => data,
  fromFirestore: (snapshot, options) => {
    const result = TransportRequestZod.safeParse(snapshot.data(options))
    if (!result.success) {
      throw new ErrorWithSentryCaptureContext(
        `Invalid transportRequest ${snapshot.id}`,
        {
          tags: { 'firestore.zod': 'transportRequests' },
          fingerprint: ['firestore', 'zod', 'transportRequests'],
          extra: { data: snapshot.data(options), document: { path: snapshot.ref.path } },
        },
        { cause: result.error }
      )
    }
    return { _id: snapshot.id, ...result.data }
  },
}

export const transportRequestCollection = () =>
  collection(getFirestore(), 'transportRequests').withConverter(TransportRequestConverter)

export const transportRequestDocument = (id: string) =>
  doc(getFirestore(), 'transportRequests', id).withConverter(TransportRequestConverter)
